<template>
  <div class="c-banner-main grid grid-cols-2 gap-x-4 px-7 py-4 bg-center bg-no-repeat bg-cover rounded-t-xl">
    <div class="flex flex-col justify-center col-span-2 lg:col-span-1">
      <div
        class="c-banner-main__title pb-3 text-4xl text-basic-high font-normal leading-10"
        v-html="translations['banner-main-title']"
      />
      <div
        class="c-banner-main__description font-body2 w-full lg:w-9/12"
        v-html="translations['banner-main-description']"
      />
    </div>
    <div class="hidden justify-center items-center col-span-1 lg:flex">
      <div class="c-banner-main__logo w-full bg-top bg-no-repeat bg-contain"/>
    </div>
  </div>
</template>

<script>
import Translation from 'dcode/classes/Translation'

export default {
  name: 'CBannerMain',
  setup () {
    const translations = Translation.getByList([
      'banner-main-description',
      'banner-main-title'
    ])

    return {
      translations
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
